import type { RelativeDatePresetOption } from '@models/date.models';

export const RELATIVE_DATE_PRESET_OPTIONS = {
  '24h': {
    label: 'Last 24 hours',
    days: 1,
  },
  '7d': {
    label: 'Last 7 days',
    days: 7,
  },
  '30d': {
    label: 'Last 30 days',
    days: 30,
  },
  '60d': {
    label: 'Last 60 days',
    days: 60,
  },
  '90d': {
    label: 'Last 90 days',
    days: 90,
  },
  '180d': {
    label: 'Last 180 days',
    days: 180,
  },
  '270d': {
    label: 'Last 270 days',
    days: 270,
  },
  '365d': {
    label: 'Last 365 days',
    days: 365,
  },
} as const satisfies Record<string, RelativeDatePresetOption>;
